import { render, staticRenderFns } from "./SecondaryText.vue?vue&type=template&id=a2c08404&scoped=true&"
var script = {}
import style0 from "./SecondaryText.vue?vue&type=style&index=0&id=a2c08404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c08404",
  null
  
)

export default component.exports